import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const ERROR_MESSAGES = {
  auth_failed: 'Could not start Microsoft sign-in. Try again.',
  no_code:    'Microsoft did not return an authorization code.',
  no_email:   'Microsoft did not return an email for your account.',
  domain_not_allowed: 'Your Microsoft account is not in an allowed domain.',
  account_inactive:   'Your account has been deactivated. Contact your administrator.',
  callback_failed:    'Sign-in failed during the Microsoft callback. Try again.',
};

function Login() {
  const { login, isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const errorCode = params.get('error');
  const errorMessage = errorCode ? (ERROR_MESSAGES[errorCode] || `Sign-in error: ${errorCode}`) : null;

  useEffect(() => {
    if (isAuthenticated) navigate('/dashboard', { replace: true });
  }, [isAuthenticated, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-8">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-gray-900">PM Training & Onboarding</h1>
          <p className="mt-2 text-sm text-gray-600">Sign in with your Microsoft work account to continue.</p>
        </div>

        {errorMessage && (
          <div className="mb-6 rounded-md bg-red-50 p-3 text-sm text-red-700 border border-red-200">
            {errorMessage}
          </div>
        )}

        <button
          type="button"
          onClick={login}
          className="w-full flex items-center justify-center gap-3 px-4 py-3 border border-gray-300 rounded-md bg-white hover:bg-gray-50 text-gray-800 font-medium shadow-sm"
        >
          <svg width="20" height="20" viewBox="0 0 21 21" aria-hidden="true">
            <rect x="1" y="1" width="9" height="9" fill="#f25022" />
            <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
            <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
            <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
          </svg>
          Sign in with Microsoft
        </button>

        <p className="mt-6 text-xs text-gray-500 text-center">
          Access is controlled by your organization. If you can't sign in, contact your administrator.
        </p>
      </div>
    </div>
  );
}

export default Login;
